module.exports = __webpack_public_path__ + "static/media/FiltradoVerde.64ffb568.pdf";